import React, {lazy, Suspense} from 'react';

import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

const loadable = ({loader}: any) => {
	const Component = lazy(loader);
	return (props: any) => (
		<Suspense
			fallback={
				<SpinnerContainer show>
					<Trans i18nKey="elements.loadingComponent.loading">Loading component...</Trans>
				</SpinnerContainer>
			}>
			<Component {...props} />
		</Suspense>
	);
};

export default loadable;
